<template>
    <div>
        <div v-if="master_installation.id">
            <b-row sm="12">
                <b-col sm="5">
                    <installation-code-input :installation-code="master_installation.installation_code"
                                             :validation="validation_master_installation.installation_code"
                                             @update="handleUpdateFields"/>
                </b-col>
                <b-col sm="5">
                    <client-input :client="master_installation.client"
                                  :validation="validation_master_installation.client"
                                  disabled
                                  @update="handleUpdateFields"></client-input>
                </b-col>
                <b-col sm="2">
                    <b-button v-if="edit && activeTab === 0" variant="outline-success" block class="mt-2" @click="updateInstallation()">
                        Guardar
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <div v-if="!master_installation.id">
            <b-row sm="12">
                <b-col sm="2">
                    <segment-id-select :segment-id="master_installation.segment_id"
                                       :validation="validation_master_installation.segment_id"
                                       @update="handleUpdateFields"
                    />
                </b-col>
                <b-col sm="2">
                  <typology-id-select :typology-id="master_installation.typology_id" :validation="validation_master_installation.typology_id" @update="handleUpdateFields" />
                </b-col>
                <b-col sm="2">
                    <company-input :company-id="master_installation.company_id" :disabled="isDisabled"
                                   :validation="validation_master_installation.company_id"
                                   @update="handleUpdateFields"/>
                </b-col>
                <b-col sm="3">
                    <date-start-flat-pickr :date-start="master_installation.start_date"
                                           :validation="validation_master_installation.start_date"
                                           @update="handleUpdateFields"/>
                </b-col>
                <b-col sm="3">
                    <date-end-flat-pickr :date-end="master_installation.end_date"
                                         :validation="validation_master_installation.end_date"
                                         @update="handleUpdateFields"/>
                </b-col>
            </b-row>
            <b-row sm="12">
                <b-col sm="10">
                    <installation-code-concat-input :installation-type-code="master_installation.typology_name"
                                             :segment-code="master_installation.segment_code"
                                             :installation-code="master_installation.installation_code"
                                             :installation-id="master_installation.id"
                                             :validation="validation_master_installation.installation_code"
                                             @update="handleUpdateFields"/>
                </b-col>
            </b-row>
          <hr class="mb-2">
          <b-row class="d-flex justify-content-end mt-2" v-if="!edit">
            <b-col sm="2">
              <b-button  variant="outline-success" block @click="createInstallation()">
                Crear
              </b-button>
            </b-col>
          </b-row>
        </div>
    </div>
</template>
<script>
import {BCol, BRow, BButton} from 'bootstrap-vue'
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"

import segmentIdSelect from "@/views/gei/masters_installations/form/formHeader/components/segmentIdSelect"
import installationCodeInput from "@/views/gei/masters_installations/form/formHeader/components/installationCodeInput"
import installationCodeConcatInput from "@/views/gei/masters_installations/form/formHeader/components/installationCodeConcatInput"
import clientInput from "@/views/gei/masters_installations/form/formInstallationData/components/clientInput"
import DateStartFlatPickr
    from "@/views/gei/masters_installations/form/formInstallationData/components/dateStartFlatPickr.vue"
import DateEndFlatPickr
    from "@/views/gei/masters_installations/form/formInstallationData/components/dateEndFlatPickr.vue"
import companyInput from "@/views/gei/masters_installations/form/formInstallationData/components/companyInput"
import typologyIdSelect
  from "@/views/gei/masters_installations/form/formInstallationData/components/typologyIdSelect.vue"

import {GEI_MASTERS_INSTALLATIONS_LIST} from "@/router/web/constants"

const {mapFields} = createHelpers({
    getterType: 'masterInstallation/getField',
    mutationType: 'masterInstallation/updateField',
})

export default {
    components: {
        DateEndFlatPickr,
        DateStartFlatPickr,
        clientInput,
        installationCodeInput,
        installationCodeConcatInput,
        segmentIdSelect,
        typologyIdSelect,
        companyInput,

        BCol,
        BRow,
        BButton,
    },
    props: {
      activeTab: {
        type: Number,
        required: true,
      },
    },
    data() {
        return {
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('masterInstallation', ['validation_master_installation']),
        ...mapFields({
            master_installation: 'master_installation',
        }),
    },

    mounted() {
        if (this.$route.params.id) {
            this.edit = true
        } else {
            this.edit = false
        }
    },

    methods: {
        handleUpdateFields(updatedFields) {
            this.master_installation = {...this.master_installation, ...updatedFields}
        },
        createInstallation() {
            this.$root.$refs.masterInstallationForm.createInstallation()
        },
        updateInstallation() {
            this.$root.$refs.masterInstallationForm.updateInstallation()
        },

    },

}
</script>